import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import LogoContainer from "../common/LogoContainer";

function AccessRequest() {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );

    const showLogoOnRegistrationScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.includePartnerLogo
            : false
    );

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <div className="row margin-vertical-xl">
            <div className={`box ${renderSiteInIFrame ? "col-xs-12" : ""} box-has-shadow box-lg`}>
                {showLogoOnRegistrationScreens && (
                    <div className="col-xs-0 col-sm-12 row flex-end">
                        <LogoContainer internalPage={false} className="hide-mobile" showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                    </div>
                )}

                {showLogoOnRegistrationScreens && (
                    <div className="col-xs-12 col-sm-0 hide-sm-up text-align-center">
                        <LogoContainer internalPage={false} showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                    </div>
                )}

                <div className="box-description flex-center justify-center">
                    <div className="row row-container">
                        <div className="col-sm-3"></div>
                        <div className="col-xs-12 col-sm-12 text-align-center col-main">
                            <div>
                                <h3 className="error-page-title">Enable browser permissions</h3>
                                <p>
                                    To access Identity Theft Protection on your browser, please allow the use of cookies on the next screen. This information is
                                    used only to display the features available in Identity Theft Protection and keep your data secure.
                                </p>
                            </div>
                            <div className="col-xs-12 justify-center text-align-center col-main pt-2">
                                <button
                                    type="button"
                                    className="btn-default btn-primary btn-min-width"
                                    onClick={() => {
                                        window.history.back();
                                        window.addToDataLayer({ event: "enableCookieAccessRequest" });
                                    }}
                                >
                                    <span className="btn-text">Continue</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AccessRequest;
